(function () {
  'use strict';

  var config = window.kgaAssetUrls || {};
  var pending = {};
  var slickReadyEventSent = false;

  function loadStylesheet(key, url) {
    if (!url || document.querySelector('link[data-kga-asset="' + key + '"]')) {
      return;
    }

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.dataset.kgaAsset = key;
    document.head.appendChild(link);
  }

  function loadScript(key, url, ready) {
    if (typeof ready === 'function' && ready()) return Promise.resolve();
    if (!url) return Promise.reject(new Error('Missing asset URL: ' + key));
    if (pending[key]) return pending[key];

    pending[key] = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-kga-asset="' + key + '"]');
      var script = existing || document.createElement('script');

      if (existing && existing.dataset.kgaLoaded === 'true') {
        resolve();
        return;
      }

      script.addEventListener('load', function () {
        script.dataset.kgaLoaded = 'true';
        resolve();
      }, { once: true });

      script.addEventListener('error', function () {
        delete pending[key];
        reject(new Error('Unable to load asset: ' + key));
      }, { once: true });

      if (!existing) {
        script.src = url;
        script.async = true;
        script.dataset.kgaAsset = key;
        document.head.appendChild(script);
      }
    });

    return pending[key];
  }

  window.loadKgaSlick = function () {
    return loadScript('slick', config.slick, function () {
      return Boolean(window.jQuery && window.jQuery.fn && window.jQuery.fn.slick);
    }).then(function () {
      if (slickReadyEventSent) return;
      slickReadyEventSent = true;
      document.dispatchEvent(new CustomEvent('kga:slick:ready'));
    });
  };

  window.loadKgaPredictiveSearch = function () {
    loadStylesheet('predictive-search-css', config.predictiveSearchCss);
    return loadScript('predictive-search', config.predictiveSearch, function () {
      return Boolean(window.customElements && window.customElements.get('predictive-search'));
    });
  };

  function closestTarget(event, selector) {
    return event.target instanceof Element ? event.target.closest(selector) : null;
  }

  function onIntent(event) {
    if (closestTarget(event, '[data-open-search], predictive-search, .kga-search')) {
      window.loadKgaPredictiveSearch().catch(function () {});
    }

    if (closestTarget(event, '.quickview-btn, [data-kga-requires-slick]')) {
      window.loadKgaSlick().catch(function () {});
    }
  }

  document.addEventListener('pointerdown', onIntent, { capture: true, passive: true });
  document.addEventListener('focusin', onIntent, true);

  function initializeDeferredAssets() {
    if (config.preloadSlickDesktop && window.matchMedia('(min-width: 768px)').matches) {
      window.loadKgaSlick().catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDeferredAssets, { once: true });
  } else {
    initializeDeferredAssets();
  }
})();
